<div class="collections-filter">
  <div class="alphabet flex-container align-spaced">
    <a (click)="handleCharacter($event,'active', 'A')"
       [ngClass]="{'disabled': !charactersActive.includes('A')}"
       class="character a"
    >A</a>
    <a (click)="handleCharacter($event,'active', 'B')"
       [ngClass]="{'disabled': !charactersActive.includes('B')}"
       class="character b"
    >B</a>
    <a (click)="handleCharacter($event,'active', 'C')"
       [ngClass]="{'disabled': !charactersActive.includes('C')}"
       class="character c"
    >C</a>
    <a (click)="handleCharacter($event,'active', 'D')"
       [ngClass]="{'disabled': !charactersActive.includes('D')}"
       class="character d"
    >D</a>
    <a (click)="handleCharacter($event,'active', 'E')"
       [ngClass]="{'disabled': !charactersActive.includes('E')}"
       class="character e"
    >E</a>
    <a (click)="handleCharacter($event,'active', 'F')"
       [ngClass]="{'disabled': !charactersActive.includes('F')}"
       class="character f"
    >F</a>
    <a (click)="handleCharacter($event,'active', 'G')"
       [ngClass]="{'disabled': !charactersActive.includes('G')}"
       class="character g"
    >G</a>
    <a (click)="handleCharacter($event,'active', 'H')"
       [ngClass]="{'disabled': !charactersActive.includes('H')}"
       class="character h"
    >H</a>
    <a (click)="handleCharacter($event,'active', 'I')"
       [ngClass]="{'disabled': !charactersActive.includes('I')}"
       class="character i"
    >I</a>
    <a (click)="handleCharacter($event,'active', 'J')"
       [ngClass]="{'disabled': !charactersActive.includes('J')}"
       class="character j"
    >J</a>
    <a (click)="handleCharacter($event,'active', 'K')"
       [ngClass]="{'disabled': !charactersActive.includes('K')}"
       class="character k"
    >K</a>
    <a (click)="handleCharacter($event,'active', 'L')"
       [ngClass]="{'disabled': !charactersActive.includes('L')}"
       class="character l"
    >L</a>
    <a (click)="handleCharacter($event,'active', 'M')"
       [ngClass]="{'disabled': !charactersActive.includes('M')}"
       class="character m"
    >M</a>
    <a (click)="handleCharacter($event,'active', 'N')"
       [ngClass]="{'disabled': !charactersActive.includes('N')}"
       class="character n"
    >N</a>
    <a (click)="handleCharacter($event,'active', 'O')"
       [ngClass]="{'disabled': !charactersActive.includes('O')}"
       class="character o"
    >O</a>
    <a (click)="handleCharacter($event,'active', 'P')"
       [ngClass]="{'disabled': !charactersActive.includes('P')}"
       class="character p"
    >P</a>
    <a (click)="handleCharacter($event,'active', 'Q')"
       [ngClass]="{'disabled': !charactersActive.includes('Q')}"
       class="character q"
    >Q</a>
    <a (click)="handleCharacter($event,'active', 'R')"
       [ngClass]="{'disabled': !charactersActive.includes('R')}"
       class="character r"
    >R</a>
    <a (click)="handleCharacter($event,'active', 'S')"
       [ngClass]="{'disabled': !charactersActive.includes('S')}"
       class="character s"
    >S</a>
    <a (click)="handleCharacter($event,'active', 'T')"
       [ngClass]="{'disabled': !charactersActive.includes('T')}"
       class="character t"
    >T</a>
    <a (click)="handleCharacter($event,'active', 'U')"
       [ngClass]="{'disabled': !charactersActive.includes('U')}"
       class="character u"
    >U</a>
    <a (click)="handleCharacter($event,'active', 'V')"
       [ngClass]="{'disabled': !charactersActive.includes('V')}"
       class="character v"
    >V</a>
    <a (click)="handleCharacter($event,'active', 'W')"
       [ngClass]="{'disabled': !charactersActive.includes('W')}"
       class="character w"
    >W</a>
    <a (click)="handleCharacter($event,'active', 'X')"
       [ngClass]="{'disabled': !charactersActive.includes('X')}"
       class="character x"
    >X</a>
    <a (click)="handleCharacter($event,'active', 'Y')"
       [ngClass]="{'disabled': !charactersActive.includes('Y')}"
       class="character y"
    >Y</a>
    <a (click)="handleCharacter($event,'active', 'Z')"
       [ngClass]="{'disabled': !charactersActive.includes('Z')}"
       class="character z"
    >Z</a>
  </div>
  <div
    class="product-filter-collections flex-container wrap justify-center align-center-middle grid-gap-big margin-t-1">
    <div (click)="handleCollectionCategoriesSelected('Crockery', '1')"
         [ngClass]="{'selected': !collectionCategoriesSelected.Crockery}"
         class="filter-item shrink"
    >
      <span class="img-wrapper">
        <svg height="17" viewBox="0 0 21.359 21.359" width="17">
              <g data-name="Gruppe 280" id="Gruppe_280" transform="translate(-0.061 -0.061)">
                <path class="circle" d="M21.859,11.18A10.68,10.68,0,1,1,11.179.5,10.68,10.68,0,0,1,21.859,11.18Z"
                      data-name="Pfad 56"
                      id="Pfad_56" transform="translate(-0.439 -0.439)"/>
                <path class="checkmark" d="M17.591,28.481,21.71,32.6l7.174-7.174" data-name="Pfad 57"
                      fill="none" id="Pfad_57" stroke="#fff" stroke-linecap="round"
                      stroke-miterlimit="10" stroke-width="1" transform="translate(-12.497 -18.025)"/>
              </g>
            </svg>
      </span>{{'collections-filter.crockery' | i18next}}
    </div>
    <div (click)="handleCollectionCategoriesSelected('Glassware','7')"
         [ngClass]="{'selected': !collectionCategoriesSelected.Glassware}"
         class="filter-item shrink">
      <span class="img-wrapper">
        <svg height="17" viewBox="0 0 21.359 21.359" width="17">
              <g data-name="Gruppe 280" id="Gruppe_280" transform="translate(-0.061 -0.061)">
                <path class="circle" d="M21.859,11.18A10.68,10.68,0,1,1,11.179.5,10.68,10.68,0,0,1,21.859,11.18Z"
                      data-name="Pfad 56"
                      id="Pfad_56" transform="translate(-0.439 -0.439)"/>
                <path class="checkmark" d="M17.591,28.481,21.71,32.6l7.174-7.174" data-name="Pfad 57"
                      fill="none" id="Pfad_57" stroke="#fff" stroke-linecap="round"
                      stroke-miterlimit="10" stroke-width="1" transform="translate(-12.497 -18.025)"/>
              </g>
            </svg>
      </span>{{'collections-filter.glassware' | i18next}}
    </div>
    <div (click)="handleCollectionCategoriesSelected('Cutlery', '1')"
         [ngClass]="{'selected': !collectionCategoriesSelected.Cutlery}"
         class="filter-item shrink"
    >
      <span class="img-wrapper">
        <svg height="17" viewBox="0 0 21.359 21.359" width="17">
              <g data-name="Gruppe 280" id="Gruppe_280" transform="translate(-0.061 -0.061)">
                <path class="circle" d="M21.859,11.18A10.68,10.68,0,1,1,11.179.5,10.68,10.68,0,0,1,21.859,11.18Z"
                      data-name="Pfad 56"
                      id="Pfad_56" transform="translate(-0.439 -0.439)"/>
                <path class="checkmark" d="M17.591,28.481,21.71,32.6l7.174-7.174" data-name="Pfad 57"
                      fill="none" id="Pfad_57" stroke="#fff" stroke-linecap="round"
                      stroke-miterlimit="10" stroke-width="1" transform="translate(-12.497 -18.025)"/>
              </g>
            </svg>
      </span>{{'collections-filter.cutlery' | i18next}}
    </div>
    <div (click)="handleCollectionCategoriesSelected('Gifts', '3')"
         [ngClass]="{'selected': !collectionCategoriesSelected.Gifts}"
         class="filter-item shrink">
      <span class="img-wrapper">
        <svg height="17" viewBox="0 0 21.359 21.359" width="17">
              <g data-name="Gruppe 280" id="Gruppe_280" transform="translate(-0.061 -0.061)">
                <path class="circle" d="M21.859,11.18A10.68,10.68,0,1,1,11.179.5,10.68,10.68,0,0,1,21.859,11.18Z"
                      data-name="Pfad 56"
                      id="Pfad_56" transform="translate(-0.439 -0.439)"/>
                <path class="checkmark" d="M17.591,28.481,21.71,32.6l7.174-7.174" data-name="Pfad 57"
                      fill="none" id="Pfad_57" stroke="#fff" stroke-linecap="round"
                      stroke-miterlimit="10" stroke-width="1" transform="translate(-12.497 -18.025)"/>
              </g>
            </svg>
      </span>{{'collections-filter.gifts' | i18next}}
    </div>
    <div (click)="handleCollectionCategoriesSelected('Baking', '10')"
         [ngClass]="{'selected': !collectionCategoriesSelected.Baking}"
         class="filter-item shrink">
      <span class="img-wrapper">
        <svg height="17" viewBox="0 0 21.359 21.359" width="17">
              <g data-name="Gruppe 280" id="Gruppe_280" transform="translate(-0.061 -0.061)">
                <path class="circle" d="M21.859,11.18A10.68,10.68,0,1,1,11.179.5,10.68,10.68,0,0,1,21.859,11.18Z"
                      data-name="Pfad 56"
                      id="Pfad_56" transform="translate(-0.439 -0.439)"/>
                <path class="checkmark" d="M17.591,28.481,21.71,32.6l7.174-7.174" data-name="Pfad 57"
                      fill="none" id="Pfad_57" stroke="#fff" stroke-linecap="round"
                      stroke-miterlimit="10" stroke-width="1" transform="translate(-12.497 -18.025)"/>
              </g>
            </svg>
      </span>{{'collections-filter.baking' | i18next}}
    </div>
    <div (click)="handleCollectionCategoriesSelected('Kids', '9')"
         [ngClass]="{'selected': !collectionCategoriesSelected.Kids}"
         class="filter-item shrink">
      <span class="img-wrapper">
        <svg height="17" viewBox="0 0 21.359 21.359" width="17">
              <g data-name="Gruppe 280" id="Gruppe_280" transform="translate(-0.061 -0.061)">
                <path class="circle" d="M21.859,11.18A10.68,10.68,0,1,1,11.179.5,10.68,10.68,0,0,1,21.859,11.18Z"
                      data-name="Pfad 56"
                      id="Pfad_56" transform="translate(-0.439 -0.439)"/>
                <path class="checkmark" d="M17.591,28.481,21.71,32.6l7.174-7.174" data-name="Pfad 57"
                      fill="none" id="Pfad_57" stroke="#fff" stroke-linecap="round"
                      stroke-miterlimit="10" stroke-width="1" transform="translate(-12.497 -18.025)"/>
              </g>
            </svg>
      </span>{{'collections-filter.kids' | i18next}}
    </div>
    <div (click)="handleCollectionCategoriesSelected('Novelties', '12')"
         [ngClass]="{'selected': !collectionCategoriesSelected.Novelties}"
         class="filter-item shrink">
      <span class="img-wrapper">
        <svg height="17" viewBox="0 0 21.359 21.359" width="17">
              <g data-name="Gruppe 280" id="Gruppe_280" transform="translate(-0.061 -0.061)">
                <path class="circle" d="M21.859,11.18A10.68,10.68,0,1,1,11.179.5,10.68,10.68,0,0,1,21.859,11.18Z"
                      data-name="Pfad 56"
                      id="Pfad_56" transform="translate(-0.439 -0.439)"/>
                <path class="checkmark" d="M17.591,28.481,21.71,32.6l7.174-7.174" data-name="Pfad 57"
                      fill="none" id="Pfad_57" stroke="#fff" stroke-linecap="round"
                      stroke-miterlimit="10" stroke-width="1" transform="translate(-12.497 -18.025)"/>
              </g>
            </svg>
      </span>{{'collections-filter.news' | i18next}}
    </div>
    <div (click)="handleCollectionCategoriesSelected('Xmas', '8')"
         [ngClass]="{'selected': !collectionCategoriesSelected.Xmas}"
         class="filter-item shrink selected">
      <span class="img-wrapper">
        <svg height="17" viewBox="0 0 21.359 21.359" width="17">
              <g data-name="Gruppe 280" id="Gruppe_280" transform="translate(-0.061 -0.061)">
                <path class="circle" d="M21.859,11.18A10.68,10.68,0,1,1,11.179.5,10.68,10.68,0,0,1,21.859,11.18Z"
                      data-name="Pfad 56"
                      id="Pfad_56" transform="translate(-0.439 -0.439)"/>
                <path class="checkmark" d="M17.591,28.481,21.71,32.6l7.174-7.174" data-name="Pfad 57"
                      fill="none" id="Pfad_57" stroke="#fff" stroke-linecap="round"
                      stroke-miterlimit="10" stroke-width="1" transform="translate(-12.497 -18.025)"/>
              </g>
            </svg></span>{{'collections-filter.xmas' | i18next}}
    </div>
    <div (click)="handleCollectionCategoriesSelected('Easter', '11')"
         [ngClass]="{'selected': !collectionCategoriesSelected.Easter}"
         class="filter-item shrink selected">
      <span class="img-wrapper">
        <svg height="17" viewBox="0 0 21.359 21.359" width="17">
              <g data-name="Gruppe 280" id="Gruppe_280" transform="translate(-0.061 -0.061)">
                <path class="circle" d="M21.859,11.18A10.68,10.68,0,1,1,11.179.5,10.68,10.68,0,0,1,21.859,11.18Z"
                      data-name="Pfad 56"
                      id="Pfad_56" transform="translate(-0.439 -0.439)"/>
                <path class="checkmark" d="M17.591,28.481,21.71,32.6l7.174-7.174" data-name="Pfad 57"
                      fill="none" id="Pfad_57" stroke="#fff" stroke-linecap="round"
                      stroke-miterlimit="10" stroke-width="1" transform="translate(-12.497 -18.025)"/>
              </g>
            </svg>
      </span>{{'collections-filter.easter' | i18next}}
    </div>
  </div>
</div>

